import EstoqueStService from "@/services/EstoqueStService";

export const estoqueSt = {
  namespaced: true,
  state: {
    estoqueSt: {},
  },
  actions: {
    getEstoqueSt({ commit }, payload) {
      return EstoqueStService.GetEstoqueSt(payload).then(
        (estoqueSt) => {
          return Promise.resolve(estoqueSt);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postEstoqueSt({ commit }, payload) {
      return EstoqueStService.PostEstoqueSt(payload).then(
        (estoqueSt) => {
          return Promise.resolve(estoqueSt);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putEstoqueSt({ commit }, payload) {
      return EstoqueStService.PutEstoqueSt(payload).then(
        (estoqueSt) => {
          return Promise.resolve(estoqueSt);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteEstoqueSt({ commit }, payload) {
      return EstoqueStService.DeleteEstoqueSt(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getEstoqueStOData({ commit }, payload) {
      return EstoqueStService.GetEstoqueStOData(payload).then(
        (estoqueSt) => {
          return Promise.resolve(estoqueSt);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default estoqueSt;
